import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Message } from '@design-system-coopeuch/web';
import { stepperAction } from '../../../../application/actions/stepper';
import { sucursalActions } from '../../../../application/actions/sucursal';
import { Wrapper } from './styles';
import { properties } from '../../../../utils/properties'
import Comprobante from '../../atoms/Comprobante';
import DocumentoSucursalTemplate from '../../atoms/DocumentosSucursal';

const ComprobanteTemplate = ({ activeMenu, fechaCreacionSolitud}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [data, setData] = useState({});
  const [diasFaltantes, setDiasFaltantes] = useState('');
  const [email, setEmail] = useState('')
  const [fechaCreacionAux, setFechaCreacionAux] = useState('');

  useEffect(() => {
    dispatch(stepperAction.fetchStepper(activeMenu));
  }, [activeMenu]);

  const responseSaveFromStore = useSelector(store => store.entities.sucursal.responseSave);

  useEffect(() => {
    if (Object.keys(responseSaveFromStore).length === 0) {
      dispatch(sucursalActions.saveSucursal({ trackId: window.localStorage.getItem('track_id') }));
    }
  }, []);

  useEffect(() => {
    try {
      if ('code' in responseSaveFromStore && responseSaveFromStore.code === -1) {
        window.localStorage.setItem('paso', '/comprobante');
        history.push('/error-conexion');
      }
      if ('data' in responseSaveFromStore) {
        setData(responseSaveFromStore.data);
        setDiasFaltantes(responseSaveFromStore.data.diasFaltantes);
        setFechaCreacionAux(responseSaveFromStore.data.fechaCreacion);
        setEmail(responseSaveFromStore.data.email);
      }
    } catch {
      window.location.replace('/');
    }
  }, [responseSaveFromStore]);

  return (
    <Wrapper>
      <form>
        <div className="mensaje">
          <Message
            title={properties.comprobante.title}
            description={properties.comprobante.Mensaje.texto}
            type="success"
          />
        </div>
        {data && diasFaltantes && (fechaCreacionAux || fechaCreacionSolitud) &&
          <Comprobante
            data={data}
            fechaCreacion={fechaCreacionAux || fechaCreacionSolitud}
            email={email}
          />}
        <DocumentoSucursalTemplate />
      </form>
    </Wrapper>
  )
}
ComprobanteTemplate.propTypes = {
  activeMenu: PropTypes.number,
  fechaCreacionSolitud: PropTypes.string

};
ComprobanteTemplate.defaultProps = ({
  activeMenu: '',
  fechaCreacionSolitud: ''
});

export default ComprobanteTemplate;